import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import useQuery from '../../util/hooks/useQuery';
import { EmptyPage } from '../../components/EmptyPage/EmptyPage';
import SectionLoader from '../../components/SectionLoader/SectionLoader';
import { storeInSessionStorage } from '../../util/helpers/sessionStorageHelper';
import {
  EMAIL,
  IS_SALES_ASSESSTED_REGISTRATION_FLOW,
  SALES_ASSISTED_QUERY_DATA,
} from '../../constants/sessionStorage';
import {
  authenticateSalesAssistedUser,
  fetchSalesAssistedApplications,
} from '../../store/actions/salesAssisted/salesAsssistedActions';
import { PAGES } from '../../constants/pages';
import ExistingApplicationModal from '../../components/Modals/ExistingApplicationModal/ExistingApplicationModal';
import { CREATE_NEW_APPLICATION } from '../../util/constants';

const SalesAssistedImpersonate = () => {
  const query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();
  const { logonUid, username, brokerCode, customerEmail, token } = query;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState({});

  const continueApplication = () => {
    history.push(PAGES.LOADING);
    document.body.style.overflow = 'unset';
  };

  const startNewApplication = () => {
    storeInSessionStorage(CREATE_NEW_APPLICATION, true);
    history.push(PAGES.CHOOSE_APPLICATION.MAIN);
    document.body.style.overflow = 'unset';
  };

  const onSuccess = (data) => {
    if (data.length > 0 && !data[0]?.IsCompletedApplication) {
      setSelectedApplication(data[0]);
      setIsModalOpen(true);
    } else {
      history.push(PAGES.CHOOSE_APPLICATION.MAIN);
    }
  };

  useEffect(() => {
    if (!token) {
      return;
    }
    if (!customerEmail) {
      return;
    }
    if (token && customerEmail) {
      storeInSessionStorage(IS_SALES_ASSESSTED_REGISTRATION_FLOW, true);
      storeInSessionStorage(SALES_ASSISTED_QUERY_DATA, {
        customerEmail,
        token,
      });
    }
    dispatch(
      authenticateSalesAssistedUser({
        data: { InvitationToken: token, CustomerEmail: customerEmail },
        onSuccess: onSuccessAutheticate,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logonUid, username, customerEmail, brokerCode]);

  const onSuccessAutheticate = () => {
    if (customerEmail) {
      storeInSessionStorage(EMAIL, customerEmail);
    }
    if (customerEmail) {
      dispatch(
        fetchSalesAssistedApplications({
          data: {
            userEmail: decodeURIComponent(customerEmail),
            brokerCode,
          },
          onSuccess,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <EmptyPage>
      <SectionLoader isLoading />
      {isModalOpen && (
        <ExistingApplicationModal
          isOpen={isModalOpen}
          createdOn={selectedApplication.CreatedOn}
          createdBy={selectedApplication.CreatedBy}
          continueApplication={continueApplication}
          startNewApplication={startNewApplication}
        />
      )}
    </EmptyPage>
  );
};

export default SalesAssistedImpersonate;
